let state = {
  playing: false,
  connected: false,
  type: 'sine',
  frequency: 440,
  amplitude: 0.1,
  pan: 0,
  filterFrequency: 22050,
  filterQuality: 0
};

const subscriptions = [];

export const getState = () => state;

export const setState = obj => {
  const oldState = {...state};

  state = {
    ...state,
    ...obj
  };

  subscriptions.forEach(s => {
    s(oldState);
  });

  return new Promise((resolve, reject) => {
    requestAnimationFrame(() => {
      resolve(getState());
    });
  });
}

export const subscribe = cb => {
  if (typeof cb === 'function') {
    subscriptions.push(cb);
  }
}
